import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { DISTRIBUTION_REPORT_API } from "./apiRoutes";

interface UseGetTraceabilityOriginReportProps {
  communityId: string;
  year: string;
  glMasterId: string;
  data: any;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getTraceabilityOriginReport = async (communityId: string, year: string, glMasterId: string, data: any) =>
  await axiosAuth.post(`${DISTRIBUTION_REPORT_API}/${communityId}/year/${year}/reports/traceability/origin/${glMasterId}/grid`, data);

const useGetTraceabilityOriginReport = ({
  queryParams,
  communityId,
  year,
  glMasterId,
  data
}: UseGetTraceabilityOriginReportProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["traceability-report-origin", communityId, year],
    queryFn: () => getTraceabilityOriginReport(communityId, year, glMasterId, data),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    enabled: !!queryParams?.enabled,
    ...queryParams,
  });
};

export default useGetTraceabilityOriginReport;
